module.exports = __webpack_public_path__ + "img/letter_head.a1abd8ef.gif";